import type { Theme } from '@mui/material';
import type { Components } from '@mui/material/styles';

export const MuiToolbar = (baseTheme: Theme): Partial<Components> => ({
  MuiToolbar: {
    styleOverrides: {
      root: {
        [baseTheme.breakpoints.up('xs')]: {
          padding: 0,
          minHeight: 0,
        },
        [baseTheme.breakpoints.down('xs')]: {
          padding: 0,
          minHeight: 0,
        },
      },
    },
  },
});
